// extracted by mini-css-extract-plugin
export default {"primary":"CircleIcon_primary__OBM7B","secondary":"CircleIcon_secondary__vna9i","none":"CircleIcon_none__k2oX1","alert":"CircleIcon_alert__q+aEo"};